export const getApiDetails = (state) => {
  return state.apiDetails.apiDetails;
};
